var flatten = function (arrayToFlatten) {
    var _a;
    return Array.isArray(arrayToFlatten) ? (_a = []).concat.apply(_a, arrayToFlatten.map(function (arrayMember) { return (Array.isArray(arrayMember) ? flatten(arrayMember) : arrayMember); })) :
        [];
};

var combineWatchers = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return flatten(args).map(function (watcher) {
        try {
            return watcher();
        }
        catch (e) {
            var error = new Error('It seems that a watcher is not a function, please check if all params of combineWatchers are of type GeneratorFunction or GeneratorFunction[]');
            error.stack = e.stack;
            throw error;
        }
    });
};

export { combineWatchers };
//# sourceMappingURL=index.es.js.map
